export default __webpack_public_path__ + "static/media/new-filter-icon.056e9370.svg";